/*
  Pet Society — global theme behavior.
  Ported from the approved Netlify site (header/mobile nav/FAQ/reveal),
  plus Shopify-native cart AJAX (Cart API: /cart.js, /cart/add.js,
  /cart/change.js) replacing the old prototype's localStorage cart.
  No frameworks, no build step — matches the site's existing engineering
  approach.
*/
(function () {
  "use strict";

  /* ---------- sticky header shadow ---------- */
  var hdr = document.getElementById("hdr");
  if (hdr) {
    var onScroll = function () {
      hdr.classList.toggle("stuck", window.scrollY > 8);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ---------- mobile nav ---------- */
  var burger = document.getElementById("burger");
  var mnav = document.getElementById("mnav");
  if (burger && mnav) {
    burger.addEventListener("click", function () {
      var open = mnav.classList.toggle("open");
      burger.setAttribute("aria-expanded", open ? "true" : "false");
    });
    mnav.addEventListener("click", function (e) {
      if (e.target.tagName === "A") {
        mnav.classList.remove("open");
        burger.setAttribute("aria-expanded", "false");
      }
    });
  }

  /* ---------- FAQ accordion ---------- */
  document.querySelectorAll(".fq").forEach(function (btn) {
    btn.setAttribute("aria-expanded", "false");
    btn.addEventListener("click", function () {
      var item = btn.parentElement;
      var panel = item.querySelector(".fa");
      var isOpen = item.classList.contains("open");
      item.parentElement.querySelectorAll(".fitem.open").forEach(function (o) {
        o.classList.remove("open");
        o.querySelector(".fq").setAttribute("aria-expanded", "false");
        o.querySelector(".fa").style.maxHeight = null;
      });
      if (!isOpen) {
        item.classList.add("open");
        btn.setAttribute("aria-expanded", "true");
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  });
  var firstFaq = document.querySelector(".fitem");
  if (firstFaq) {
    firstFaq.classList.add("open");
    firstFaq.querySelector(".fq").setAttribute("aria-expanded", "true");
    firstFaq.querySelector(".fa").style.maxHeight = firstFaq.querySelector(".fa").scrollHeight + "px";
  }
  window.addEventListener("resize", function () {
    var open = document.querySelector(".fitem.open");
    if (open) open.querySelector(".fa").style.maxHeight = open.querySelector(".fa").scrollHeight + "px";
  });

  /* ---------- reveal on scroll ---------- */
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            en.target.classList.add("in");
            io.unobserve(en.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" },
    );
    document.querySelectorAll(".rv").forEach(function (el) {
      io.observe(el);
    });
  } else {
    document.querySelectorAll(".rv").forEach(function (el) {
      el.classList.add("in");
    });
  }

  /* ============================================================
     CART — Shopify Ajax Cart API. No mock data, no localStorage.
     ============================================================ */
  var PSCart = (window.PSCart = {});

  function money(cents) {
    return (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(cents) : "₹" + (cents / 100).toFixed(2);
  }
  PSCart.money = money;

  function qs(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }

  function updateBadges(cart) {
    document.querySelectorAll(".cart-count").forEach(function (b) {
      b.textContent = cart.item_count;
      b.setAttribute("data-count", cart.item_count);
    });
  }

  function cartItemRowHtml(item) {
    var img = item.image
      ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, "_160x160$1$2") + '" alt="' + escapeHtml(item.title) + '" loading="lazy">'
      : "";
    var variantLine =
      item.variant_title && item.variant_title !== "Default Title"
        ? '<div class="cart-item-variant">' + escapeHtml(item.variant_title) + "</div>"
        : "";
    return (
      '<div class="cart-item" data-key="' +
      item.key +
      '">' +
      '<div class="cart-item-media">' +
      img +
      "</div>" +
      '<div class="cart-item-body">' +
      '<a class="cart-item-title" href="' +
      item.url +
      '">' +
      escapeHtml(item.product_title) +
      "</a>" +
      variantLine +
      '<div class="cart-item-price">' +
      money(item.final_price) +
      " each</div>" +
      '<div class="cart-item-row">' +
      '<div class="qty-stepper">' +
      '<button type="button" data-cart-qty="dec" aria-label="Decrease quantity">&minus;</button>' +
      '<input type="text" inputmode="numeric" value="' +
      item.quantity +
      '" data-cart-qty="input" aria-label="Quantity">' +
      '<button type="button" data-cart-qty="inc" aria-label="Increase quantity">+</button>' +
      "</div>" +
      '<button type="button" class="cart-remove" data-cart-remove>Remove</button>' +
      "</div>" +
      "</div>" +
      "</div>"
    );
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function renderCartDrawer(cart) {
    var itemsEl = qs("#cartItems");
    var footEl = qs("#cartFoot");
    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML =
        '<div class="cart-empty">' +
        iconCart() +
        "<p>Your cart is empty.</p>" +
        '<p class="small" style="margin-bottom:20px">Explore Pet Society essentials.</p>' +
        '<a class="btn btn-ghost btn-sm" href="/collections/all">Shop Products</a>' +
        "</div>";
      if (footEl) footEl.style.display = "none";
      return;
    }

    if (footEl) footEl.style.display = "block";
    itemsEl.innerHTML = cart.items.map(cartItemRowHtml).join("");
    var subtotalEl = qs("#cartSubtotal");
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
  }

  function fetchCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) {
      return r.json();
    });
  }
  PSCart.refresh = function () {
    return fetchCart().then(function (cart) {
      updateBadges(cart);
      renderCartDrawer(cart);
      return cart;
    });
  };

  function openDrawer() {
    var overlay = qs("#cartOverlay");
    var drawer = qs("#cartDrawer");
    if (!overlay || !drawer) return;
    overlay.classList.add("open");
    drawer.classList.add("open");
    document.body.style.overflow = "hidden";
  }
  function closeDrawer() {
    var overlay = qs("#cartOverlay");
    var drawer = qs("#cartDrawer");
    if (!overlay || !drawer) return;
    overlay.classList.remove("open");
    drawer.classList.remove("open");
    document.body.style.overflow = "";
  }
  PSCart.open = openDrawer;
  PSCart.close = closeDrawer;

  var toastTimer;
  PSCart.toast = function (message) {
    var toast = qs("#psToast");
    if (!toast) return;
    toast.innerHTML = iconCheck() + "<span>" + escapeHtml(message) + "</span>";
    toast.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove("show");
    }, 2400);
  };

  function iconCart() {
    return '<svg viewBox="0 0 24 24" fill="none"><path d="M4 6h2l2.2 11a2 2 0 002 1.6h7.1a2 2 0 002-1.6L20 8H7" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/><circle cx="10" cy="21" r="1.3" fill="currentColor"/><circle cx="17" cy="21" r="1.3" fill="currentColor"/></svg>';
  }
  function iconCheck() {
    return '<svg viewBox="0 0 16 16" fill="none"><path d="M3 8.5l3 3 7-7" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  PSCart.addItem = function (variantId, quantity) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 }),
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) throw new Error(result.data.description || "Could not add to cart.");
        return PSCart.refresh().then(function () {
          return result.data;
        });
      });
  };

  function changeLine(key, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        updateBadges(cart);
        renderCartDrawer(cart);
        return cart;
      });
  }

  document.addEventListener("DOMContentLoaded", function () {
    /* wire cart-open buttons */
    document.querySelectorAll(".cart-toggle").forEach(function (btn) {
      btn.addEventListener("click", function () {
        PSCart.refresh();
        openDrawer();
      });
    });
    var cartClose = qs("#cartClose");
    var cartOverlay = qs("#cartOverlay");
    if (cartClose) cartClose.addEventListener("click", closeDrawer);
    if (cartOverlay) cartOverlay.addEventListener("click", closeDrawer);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeDrawer();
    });

    /* quick-add forms on product cards (data-product-card-form) */
    document.querySelectorAll("[data-quick-add-form]").forEach(function (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var variantId = form.querySelector('[name="id"]').value;
        var btn = form.querySelector("[data-quick-add-submit]");
        var titleAttr = form.getAttribute("data-product-title") || "Item";
        if (btn) btn.setAttribute("aria-busy", "true");
        PSCart.addItem(variantId, 1)
          .then(function () {
            PSCart.toast("Added " + titleAttr + " to cart");
          })
          .catch(function (err) {
            PSCart.toast(err.message || "Could not add to cart.");
          })
          .then(function () {
            if (btn) btn.removeAttribute("aria-busy");
          });
      });
    });

    /* main product form (product page) */
    var productForm = qs("[data-product-form]");
    if (productForm) {
      productForm.addEventListener("submit", function (e) {
        e.preventDefault();
        var variantId = productForm.querySelector('[name="id"]').value;
        var qtyInput = productForm.querySelector('[name="quantity"]');
        var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        var submitBtn = productForm.querySelector("[data-product-form-submit]");
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.dataset.originalText = submitBtn.textContent;
          submitBtn.textContent = "Adding…";
        }
        PSCart.addItem(variantId, quantity)
          .then(function () {
            var title = productForm.getAttribute("data-product-title") || "Item";
            PSCart.toast("Added " + title + " to cart");
            openDrawer();
          })
          .catch(function (err) {
            PSCart.toast(err.message || "Could not add to cart.");
          })
          .then(function () {
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = submitBtn.dataset.originalText;
            }
          });
      });
    }

    /* cart drawer / cart page quantity + remove (event delegation) */
    document.body.addEventListener("click", function (e) {
      var incBtn = e.target.closest('[data-cart-qty="inc"]');
      var decBtn = e.target.closest('[data-cart-qty="dec"]');
      var removeBtn = e.target.closest("[data-cart-remove]");
      if (!incBtn && !decBtn && !removeBtn) return;

      var row = e.target.closest("[data-key]");
      if (!row) return;
      var key = row.getAttribute("data-key");
      var input = row.querySelector('[data-cart-qty="input"]');

      if (removeBtn) {
        changeLine(key, 0);
        return;
      }
      var current = parseInt((input && input.value) || "1", 10);
      var next = incBtn ? current + 1 : Math.max(0, current - 1);
      if (input) input.value = next;
      changeLine(key, next);
    });

    document.body.addEventListener("change", function (e) {
      var input = e.target.closest('[data-cart-qty="input"]');
      if (!input) return;
      var row = input.closest("[data-key]");
      if (!row) return;
      var value = Math.max(0, parseInt(input.value, 10) || 0);
      changeLine(row.getAttribute("data-key"), value);
    });

    /* generic quantity steppers outside the cart (product page) */
    document.querySelectorAll("[data-qty-stepper]").forEach(function (stepper) {
      var input = stepper.querySelector("input");
      stepper.querySelector('[data-qty="dec"]').addEventListener("click", function () {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        input.dispatchEvent(new Event("change"));
      });
      stepper.querySelector('[data-qty="inc"]').addEventListener("click", function () {
        input.value = (parseInt(input.value, 10) || 1) + 1;
        input.dispatchEvent(new Event("change"));
      });
    });

    /* initialize badge count on load */
    PSCart.refresh();
  });

  /* ============================================================
     PRODUCT VARIANT PICKER — updates price/availability/URL/media
     without a page reload. Progressive enhancement: works via plain
     links if JS fails (each swatch value maps to a real variant).
     ============================================================ */
  document.addEventListener("DOMContentLoaded", function () {
    var picker = qs("[data-variant-picker]");
    if (!picker) return;

    var variantsJson = qs("[data-product-variants]");
    if (!variantsJson) return;
    var variants = JSON.parse(variantsJson.textContent);

    function selectedOptions() {
      var selected = [];
      picker.querySelectorAll("[data-option-index]").forEach(function (group) {
        var checked = group.querySelector("input:checked");
        selected[parseInt(group.getAttribute("data-option-index"), 10)] = checked ? checked.value : null;
      });
      return selected;
    }

    function findVariant(options) {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return opt === options[i];
        });
      });
    }

    function updateForVariant(variant) {
      var form = qs("[data-product-form]");
      var idInput = form && form.querySelector('[name="id"]');
      var priceNow = qs("[data-price-now]");
      var priceWas = qs("[data-price-was]");
      var submitBtn = qs("[data-product-form-submit]");
      var availRow = qs("[data-product-availability]");

      if (!variant) {
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = window.psStrings.unavailable;
        }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceNow) priceNow.textContent = money(variant.price);
      if (priceWas) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceWas.textContent = money(variant.compare_at_price);
          priceWas.style.display = "";
        } else {
          priceWas.style.display = "none";
        }
      }
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        submitBtn.textContent = variant.available ? window.psStrings.addToCart : window.psStrings.soldOut;
      }
      if (availRow) {
        availRow.classList.toggle("out", !variant.available);
        availRow.querySelector("span").textContent = variant.available ? window.psStrings.inStock : window.psStrings.outOfStock;
      }
      if (variant.featured_image) {
        var mainImg = qs("[data-product-gallery-main] img");
        if (mainImg) mainImg.src = variant.featured_image.src;
      }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", variant.id);
        window.history.replaceState({}, "", url);
      }
    }

    picker.addEventListener("change", function () {
      updateForVariant(findVariant(selectedOptions()));
    });

    /* thumbnail gallery */
    document.querySelectorAll("[data-product-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var mainImg = qs("[data-product-gallery-main] img");
        document.querySelectorAll("[data-product-thumb]").forEach(function (t) {
          t.classList.remove("active");
        });
        thumb.classList.add("active");
        if (mainImg) mainImg.src = thumb.getAttribute("data-full-src");
      });
    });
  });
})();
